import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'global-input-chip',
  templateUrl: './input-chip.component.html',
  styleUrls: ['./input-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
  ]
})
export class InputChipComponent {
  @Input() isSelected = false;
  @Input() isDisabled = false;
  @Input() isChecked = false;
  @Input() name = '';
  @Output() onSelect = new EventEmitter<void>();
  @Input() value?: unknown;

  constructor() {
  }
}
